const Analytics = () => import(/* webpackChunkName: "Analytics" */ '@/views/Private/Pages/Analytics')
const Applications = () => import(/* webpackChunkName: "Applications" */ '@/views/Private/Pages/Applications/List')
const ApplicationView = () => import(/* webpackChunkName: "ApplicationEdit" */ '@/views/Private/Pages/Applications/View')
const Users = () => import(/* webpackChunkName: "Users" */ '@/views/Private/Pages/Users/List')
const UserAdd = () => import(/* webpackChunkName: "UserAdd" */ '@/views/Private/Pages/Users/Add')
const UserEdit = () => import(/* webpackChunkName: "UserEdit" */ '@/views/Private/Pages/Users/Edit')
const Profile = () => import(/* webpackChunkName: "Profile" */ '@/views/Private/Pages/Profile')
const Sources = () => import(/* webpackChunkName: "Sources" */ '@/views/Private/Pages/Sources/List')
const SourceEdit = () => import(/* webpackChunkName: "SourceEdit" */ '@/views/Private/Pages/Sources/Edit')
const Price = () => import(/* webpackChunkName: "Price" */ '@/views/Private/Pages/Price')

export default [
	{
        path: '/analytics',
        component: Analytics
    },
	{
        path: '/users',
        component: Users
    },
	{
        path: '/users/add',
        component: UserAdd
    },
	{
        path: '/users/edit/:user',
        component: UserEdit
    },
	{
        path: '/applications',
        component: Applications
    },
	{
        path: '/applications/:id',
        component: ApplicationView
    },
	{
        path: '/profile',
        component: Profile
    },
	{
        path: '/sources',
        component: Sources
    },
	{
        path: '/sources/edit/:id',
        component: SourceEdit
    },
	{
        path: '/price',
        component: Price
    }
]
